import axios from "axios";
import authHeader from "./auth-header";
import {API_URL} from "./api-uri";

const getAirports = () => {
  return axios
  .get(API_URL + "Airports", { headers: authHeader() })
  .then((response) => {
    return response.data;
  });
};

const upsertAirport = (airport) => {
  return axios
  .put(API_URL + "Airports/UpsertAirport/" + airport.id, airport)
  .then((response) => {
    return response.data;
  });
};

const deleteAirport = (airport_id) => {
  return axios.delete(API_URL + "Airports/" + airport_id).then(() => { return });
};

export default { getAirports,  upsertAirport, deleteAirport };